import { useEffect } from 'react';

export function useDisableInspect() {
  useEffect(() => {
    const blockContextMenu = (e) => e.preventDefault();

    const blockKeys = (e) => {
      if (!e.key) return;
      const key = e.key.toLowerCase();
      if (key === 'f12') return e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j', 'c'].includes(key)) {
        return e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && key === 'u') return e.preventDefault();
    };

    document.addEventListener('contextmenu', blockContextMenu);
    document.addEventListener('keydown', blockKeys);

    return () => {
      document.removeEventListener('contextmenu', blockContextMenu);
      document.removeEventListener('keydown', blockKeys);
    };
  }, []);
}
